import { createFileRoute } from '@tanstack/react-router'
import { QuickCreateOrganizationForm } from './-components/quick-create-organization-form'

function AdminQuickCreatePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Quick Create</h1>
        <p className="text-muted-foreground">Quickly create a new organization</p>
      </div>
      <QuickCreateOrganizationForm />
    </div>
  )
}

export const Route = createFileRoute('/_authed/admin/quick-create')({
  component: AdminQuickCreatePage,
})
